import React from 'react';
export const CLIENT_APP_ORIGIN = 'https://book.therideatl.com';
export default function ClientAccountDoor({ onSignOut }) {
    return <main className="min-h-screen bg-[var(--surface-canvas)] text-[var(--ink)] p-6" style={{ paddingTop: 'max(1.5rem, env(safe-area-inset-top))' }}>
        <h1 className="text-xl font-semibold">Your client app</h1>
        <p className="my-4">This is a client account — sign in at book.therideatl.com</p>
        <a className="ia-btn3d ia-comms-pill inline-flex items-center px-4 py-3" style={{ minHeight: 44 }} href={CLIENT_APP_ORIGIN}>Sign in at book.therideatl.com</a>
        <button className="block mt-4 px-4 py-3" style={{ minHeight: 44 }} onClick={onSignOut}>Sign out of this door</button>
    </main>;
}
